module.exports = __webpack_public_path__ + "img/Frame 8@2x.76d17340.png";